'use strict';

export default function (element) {

    $("[data-select-display]").each(function () {
        var selectedVal = $(this).find('option:selected').text();
        $($(this).data('select-display')).html(selectedVal);
    });

    $(document).delegate("[data-select-display]", 'change', function () {

        var selectTag = $(this);
        var selectedVal = $(this).find('option:selected').text();
        var selectedTagId = selectTag[0].id;

        if (selectedTagId === 'addressLookupOptions') {
            addressLookUp(selectedVal, selectTag);
        } else {
            $(selectTag.data('select-display')).html(selectedVal);
        }
    });

    function addressLookUp(selectedVal, selectTag) {
        var addressAbrv = selectedVal.slice(0, 25);
        $(selectTag.data('select-display')).html(addressAbrv + '...');
    }
}
